export default "__VITE_ASSET__aRKuFw5P__"